import React, { useEffect, useState, useRef } from "react";
import { Input } from "../../../components/Common";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
  Tab,
  Tabs,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import PropTypes from "prop-types";
import SkipLogic from "../SkipLogic";
import { MdDownload } from "react-icons/md";
import { LanguageList } from "../../../Service/Language.service";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AudioForm = ({
  index,
  forms,
  getPayload,
  setForms,
  formIndex,
  logicQuestionSelecteData,
  setLogicQuestionSelecteData,
  setDisplayLogicQuestionSelecteData,
  displaylogicQuestionSelecteData,
  skipLogicData,
  skipLogicCondition,
  setSkipLogicCondition,
  setDisplayLogicCondition,
  displayLogicCondition,
}) => {
  const handleChange = (event) => {
    let newArray = [...forms];
    const currentIndex = formIndex !== undefined ? formIndex : index;
    const existingQuestion = forms[currentIndex] || {};
    const newPayload = getPayload(event.target.value);
    
    const preservedIds = existingQuestion.ids || uuidv4();

    newArray[currentIndex] = {
      ...newPayload,
      ...existingQuestion,
      type: event.target.value,
      index: index,
      logicQuestionType:
        event.target.value == "text" ? "textEmail" : event.target.value,
      ids: preservedIds,
    };
    setForms(newArray);

    let newArray1 = [...logicQuestionSelecteData];
    newArray1[index] = {
      ...newPayload,
      ...existingQuestion,
      type: event.target.value,
      index: index,
      ids: preservedIds,
      name: existingQuestion.question || "",
      value: "",
    };
    setLogicQuestionSelecteData(newArray1);

    let newArray2 = [...displaylogicQuestionSelecteData];
    newArray2[index] = {
      type: event.target.value,
      index: index,
      ids: preservedIds,
      name: existingQuestion.question || "",
      value: "",
    };

    setDisplayLogicQuestionSelecteData(newArray2);
  };
  const [value, setValue] = useState(0);
  const [languageData, setLanguageData] = useState([]);
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    getLanguageList();
  }, []);

  const getLanguageList = async () => {
    let res = await LanguageList("");
    if (res?.status) {
      setLanguageData(res.data);
    }
  };

  const typingTimeoutRef = useRef(null);

  const translateText = async (text, targetLanguage) => {
    if (!text) return "";
    try {
      const response = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${targetLanguage}&dt=t&q=${encodeURIComponent(text)}`
      );
      const data = await response.json();
      if (data && data[0]) {
        return data[0].map((item) => item[0]).join("");
      }
      return text;
    } catch (error) {
      console.error("Translation error:", error);
      return text;
    }
  };

  const handleAutoTranslate = async (text, type) => {
    if (!text || text.trim() === "") return;
    setIsTranslating(true);
    try {
      const translationPromises = languageData
        .filter((l) => {
          const code = l.languageCode?.toLowerCase();
          return code !== "en" && code !== "english";
        })
        .map(async (l) => {
          let finalCode = l.languageCode?.toLowerCase();
          // Common language code mappings
          if (finalCode === "hindi") finalCode = "hi";
          if (finalCode === "gujarati") finalCode = "gu";
          if (finalCode === "tamil") finalCode = "ta";
          if (finalCode?.length > 2) finalCode = finalCode.substring(0, 2);

          const translatedText = await translateText(text, finalCode || "en");
          return {
            languageId: l._id,
            languageName: l.languageName,
            languageCode: l.languageCode,
            translatedText: translatedText,
          };
        });

      const results = await Promise.all(translationPromises);

      setForms((prevForms) => {
        let newArray = [...prevForms];
        if (!newArray[formIndex]) return prevForms;

        let multiLang = [...(newArray[formIndex].multiLanguage || [])];

        results.forEach((res) => {
          let idx = multiLang.findIndex((item) => item.languageId === res.languageId);
          if (idx > -1) {
            multiLang[idx] = {
              ...multiLang[idx],
              [type === "question" ? "question" : "instruction"]: res.translatedText,
            };
          } else {
            multiLang.push({
              languageId: res.languageId,
              languageName: res.languageName,
              languageCode: res.languageCode,
              question: type === "question" ? res.translatedText : "",
              instruction: type === "instruction" ? res.translatedText : "",
            });
          }
        });

        newArray[formIndex].multiLanguage = multiLang;
        return newArray;
      });
    } catch (error) {
      console.error("Auto translate error:", error);
    } finally {
      setIsTranslating(false);
    }
  };

  const debounceTranslate = (text, type) => {
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      handleAutoTranslate(text, type);
    }, 1000);
  };


  const handleChange1 = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        flexDirection: "row",
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <Stack sx={{ width: "100%" }}>
        <Stack
          sx={{
            backgroundColor: "white.main",
            borderRadius: "7px",
            padding: "20px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            height: "fit-content",

          }}
        >
          <Stack sx={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <Typography
              fontSize={{ xs: "10px", sm: "16px" }}
              fontWeight={500}
              mb={"2px"}
              width={"10px"}
              display={"flex"}
              flexDirection={"column"}
            >
              {formIndex + 1}.
            </Typography>
            <Stack
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <textarea
                placeholder="Please Enter your Question text here..."
                className="defaultinput textareaformcreation"
                onChange={(e) => {
                  let newArray = [...forms];
                  newArray[formIndex].question = e.target.value;
                  setForms(newArray);

                  let newArray1 = [...logicQuestionSelecteData];
                  newArray1[index].name = e.target.value;
                  setLogicQuestionSelecteData(newArray1);

                  let newArray2 = [...displaylogicQuestionSelecteData];
                  newArray2[index].name = e.target.value;
                  setDisplayLogicQuestionSelecteData(newArray2);

                  debounceTranslate(e.target.value, "question");
                }}
                value={forms[formIndex].question}
              />
              <Stack
                sx={{ display: "flex", flexDirection: "column" }}
                width={"100%"}
              >
                <Input
                  placeholder="Instruction Text"
                  onChange={(e) => {
                    let newArray = [...forms];
                    newArray[formIndex].intructinText = e.target.value;
                    setForms(newArray);
                    debounceTranslate(e.target.value, "instruction");
                  }}
                  value={forms[formIndex].intructinText}
                />
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ mt: 0.8, fontSize: "13px", color: "#555" }}
                >
                  <span style={{ fontWeight: 500 }}>Bot Read Out Instruction:</span>
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: "10px" }}>
                    <input
                      type="radio"
                      name={`botReadInstruction_${forms[formIndex].ids || formIndex}`}
                      checked={forms[formIndex].botReadInstruction === true}
                      onChange={() => {
                        let newArray = [...forms];
                        newArray[formIndex].botReadInstruction = true;
                        setForms(newArray);
                      }}
                      style={{ marginRight: "4px", cursor: "pointer" }}
                    />
                    Yes
                  </label>
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      type="radio"
                      name={`botReadInstruction_${forms[formIndex].ids || formIndex}`}
                      checked={forms[formIndex].botReadInstruction !== true}
                      onChange={() => {
                        let newArray = [...forms];
                        newArray[formIndex].botReadInstruction = false;
                        setForms(newArray);
                      }}
                      style={{ marginRight: "4px", cursor: "pointer" }}
                    />
                    No
                  </label>
                </Stack>
                {languageData.map((l) => {
                  const existingLang = (forms[formIndex].multiLanguage || []).find(item => item.languageId === l._id);
                  const langData = {
                    languageId: l._id,
                    languageName: l.languageName,
                    languageCode: l.languageCode,
                    question: existingLang?.question || "",
                    instruction: existingLang?.instruction || ""
                  };

                  return (
                    <Stack key={l._id} sx={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%", mt: 1 }}>
                      <Typography sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {l.languageName}
                        {isTranslating && <CircularProgress size={16} />}
                      </Typography>
                        <Input
                          placeholder={`${l.languageName} Question`}
                          value={langData.question}
                          style={{ width: "100%" }}
                          onChange={(e) => {
                            let newArray = [...forms];
                            let multiLang = [...(newArray[formIndex].multiLanguage || [])];
                            let idx = multiLang.findIndex(item => item.languageId === l._id);
                            const updatedLang = { ...langData, question: e.target.value };
                            if (idx > -1) {
                              multiLang[idx] = updatedLang;
                            } else {
                              multiLang.push(updatedLang);
                            }
                            newArray[formIndex].multiLanguage = multiLang;
                            setForms(newArray);
                          }}
                        />

                        <Input
                          placeholder={`${l.languageName} Instruction`}
                          value={langData.instruction}
                          style={{ width: "100%" }}
                          onChange={(e) => {
                            let newArray = [...forms];
                            let multiLang = [...(newArray[formIndex].multiLanguage || [])];
                            let idx = multiLang.findIndex(item => item.languageId === l._id);
                            const updatedLang = { ...langData, instruction: e.target.value };
                            if (idx > -1) {
                              multiLang[idx] = updatedLang;
                            } else {
                              multiLang.push(updatedLang);
                            }
                            newArray[formIndex].multiLanguage = multiLang;
                            setForms(newArray);
                          }}
                        />
                    </Stack>
                  );
                })}
              </Stack>
            </Stack>
          </Stack>
          <Stack
            sx={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "30px", marginTop: "20px" }}
            className="formcard"
          >
            <Stack className="formcreationmain">
              <Box className="headerrow">
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <FormControl>
                    <Select
                      value={forms[formIndex].type}
                      onChange={handleChange}
                      displayEmpty
                      sx={{
                        width: 300,
                        ".MuiSelect-select": {
                          padding: "10px",
                        },
                      }}
                    >
                      <MenuItem value="" sx={{ display: "flex", gap: "10px" }}>
                        Select Question Type
                      </MenuItem>
                      <MenuItem
                        value="text"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Text
                      </MenuItem>
                      <MenuItem
                        value="multiSelect"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Multiple Choice
                      </MenuItem>
                      <MenuItem
                        value="scale"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Scale
                      </MenuItem>
                      <MenuItem
                        value="DropDown"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Drop Down
                      </MenuItem>
                      <MenuItem
                        value="Metrix"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Metrix
                      </MenuItem>
                      <MenuItem
                        value="Scan"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Media Capture
                      </MenuItem>
                      <MenuItem
                        value="Audio"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        Audio
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <Box sx={{ width: "fit-content" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange1}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Options" {...a11yProps(0)} />
                        <Tab label="Logic" {...a11yProps(1)} />
                      </Tabs>
                    </Box>
                  </Box>
                </Stack>
                <label style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    style={{
                      marginRight: "10px",
                      height: "17px",
                      width: "17px",
                    }}
                    onChange={(e) => {
                      let newArray = [...forms];
                      newArray[formIndex].answerRequired = e.target.checked;
                      setForms(newArray);
                    }}
                    checked={forms[formIndex].answerRequired}
                  />
                  Answer Required
                </label>
              </Box>
            </Stack>
            <div className="verticalline"></div>
            {/* body */}
            <CustomTabPanel value={value} index={0}>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  width: "100%",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >
                  <Typography
                    fontSize={{ xs: "10px", sm: "16px" }}
                    fontWeight={500}
                    mb={"2px"}
                  >
                    Audio Upload:
                  </Typography>
                  <FormControl>
                    <RadioGroup
                      row
                      name="audioUpload"
                      value={forms[formIndex].audioUpload ? "true" : "false"}
                      onChange={(e) => {
                        let newArray = [...forms];
                        newArray[formIndex].audioUpload = e.target.value === "true";
                        setForms(newArray);
                      }}
                    >
                      <FormControlLabel value="true" control={<Radio />} label="True" />
                      <FormControlLabel value="false" control={<Radio />} label="False" />
                    </RadioGroup>
                  </FormControl>
                </Box>

                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0px",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >

                </Box>






              </Stack>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Stack spacing={2}>
                <SkipLogic
                  logicQuestionSelecteData={logicQuestionSelecteData}
                  forms={forms}
                  setForms={setForms}
                  index={index}
                  setLogicQuestionSelecteData={setLogicQuestionSelecteData}
                  skipLogicData={skipLogicData}
                  skipLogicCondition={skipLogicCondition}
                  setSkipLogicCondition={setSkipLogicCondition}
                  displayLogicCondition={displayLogicCondition}
                  setDisplayLogicCondition={setDisplayLogicCondition}
                  displaylogicQuestionSelecteData={
                    displaylogicQuestionSelecteData
                  }
                  setDisplayLogicQuestionSelecteData={
                    setDisplayLogicQuestionSelecteData
                  }
                  formIndex={formIndex}
                />
              </Stack>
            </CustomTabPanel>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AudioForm;
